import type { BetterstartNextPaths } from '@cli-types/core-engine/config.js'
import { resolveAdminNamespace } from './resolve-admin-namespace.js'

export function deriveNamespacePaths(
  namespaceValue: string,
  srcDir: boolean
): BetterstartNextPaths {
  const namespace = resolveAdminNamespace(namespaceValue)
  const appBase = srcDir ? './src/app' : './app'

  return {
    admin: `./${namespace.segment}`,
    schemas: `./${namespace.segment}/schemas`,
    pages: `${appBase}/${namespace.routeGroup}/${namespace.segment}/(authenticated)`,
    login: `${appBase}/${namespace.routeGroup}/${namespace.segment}/(auth)/login`,
    api: `${appBase}/${namespace.routeGroup}/api/${namespace.segment}`
  }
}
